<template>
  <div class="">
    <div class="innerItem">
      <p class="innerTitle setLabel">{{locale.setting_site_title}}</p>
      <SetLanguageValue
        :locale="locale"
        :langValue="site.title" />
    </div>
  </div>
</template>

<script>
import UNIQUE from '@/common/unique'
import regExp from '@/common/regExp'
import UTIL from '@/common/util'
import SetLanguageValue from '@/components/Util/SetLanguageValue'

export default {
  name: 'SetSite',
  components: {
    SetLanguageValue
  },
  props: [
    'locale',
    'site',
    'lang'
  ],
  computed: {
    langValue () {
      return this.site.title
    }
  },
  data () {
    return {
      layer: false,
      responsive: 'mobile'
    }
  },
  methods: {
    setDefaultVal (target) {
      const defaultLang = this.lang.default
      const fillLangs = UTIL.fillLangs(this.site[target], this.site[target][defaultLang])
      this.site.title = fillLangs
    },
    onLayerOpen () {
      this.layer = true
    },
    onLayerClose () {
      this.layer = false
    },
    uploadLogo (e) {
      const data = {
        id: UNIQUE.mid(),
        file: e.target.files[0]
      }
      const isImage = regExp.image.test(data.file.name.slice(data.file.name.lastIndexOf('.') + 1).toLowerCase())
      if (isImage) {
        this.$store.dispatch('util/uploadFile', data).then((res) => {
          this.$store.commit('setting/updatdLogo', res.source)
          e.target.value = ''
        })
      } else {
        alert(this.locale.validate_upload_image)
      }
    },
    deleteLogo () {
      if (window.confirm(this.locale.confirm_delete_logo)) {
        this.$store.commit('setting/updatdLogo', '')
      }
    }
  }
}
</script>
